export const APP_BAR_ID = "app-bar";
